import { withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
//
import colors from 'theme/colors';

const { fontBody } = colors;

const KeyboardDatePickerStyled = withStyles({
  root: {
    '&.MuiInputBase-input': {
      color: fontBody,
    },
  },
})(KeyboardDatePicker);

export default KeyboardDatePickerStyled;
